






















// @ is an alias to /src
import { AloPlat } from '@/models/alo/AloPlat'
import { ItemPanier } from '@/models/alo/ItemPanier'
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'

@Component({
  name: 'Section'  
})
export default class Section extends mixins(BasePlat) {  

  

  get showAllergene(){
    return this.$store.myGetters.showAllergene
  }
  
  set showAllergene(value) {
    this.$store.myActions.UI_SET_ALLERGENE_VISIBLITY(value)
  }

  get platsDic(){
    return this.$store.myGetters.platsDic
  }

  get showAllergeneBtn() {
    return !this.printMode && this.hasAllergene(this.plat)
  }

  hasAllergene(plat:AloPlat):boolean {
    return (plat.allergenesIds && plat.allergenesIds.length > 0) || (plat.platsIds?.map(id => this.platsDic[id]) || []).some(p => this.hasAllergene(p))  
  }

  togglePlat() {      
    const mustScroll = !this.plat.selected    
    this.$store.myActions.ROOM_SERVICES_PLAT_SET_SELECTION({selected:!this.plat.selected,ids:[this.plat.id]})    
    if(mustScroll){
      setTimeout(() => {
        //@ts-ignore
        this.$vuetify.goTo(`#section_${this.plat.id}`,{duration:250,offset:10})
      }, 250) 
    }
  }

  get plats(){
    return this.plat.platsIds?.map(id => this.platsDic[id]) || []
  }
  
}
